/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */
var isElement = function (o) {
    return o instanceof Element || o instanceof HTMLDocument;
};
export default isElement;
//# sourceMappingURL=is-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-element.js
// module id = 488
// module chunks = 3